import React from 'react';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-713">
      
      <Navigation data-id="element-714" />

      <main data-id="element-715">
        <Hero data-id="element-716" />
        <WhyUs data-id="element-717" />
        <Services data-id="element-718" />
        <FAQ data-id="element-719" />
        <Testimonials data-id="element-720" />
        <Consultation data-id="element-721" />
      </main>

      <Footer data-id="element-722" />
      <CookieBanner data-id="element-723" />
      <FloatingContact data-id="element-724" />
    </div>;
}